<template>
  <BaseButton :variant="variant" @click="$emit('click')" :disabled="disabled">
    <BaseIcon v-if="isShowIcon" icon-name="unpublish" :width="iconWidth" :height="iconHeight">
      <IconUnpublish></IconUnpublish>
    </BaseIcon>
    <slot></slot>
  </BaseButton>
</template>

<script>
import buttonMixin from '@/mixins/button';
import BaseIcon from '@/components/BaseIcon.vue';
import IconUnpublish from '@/components/icon/IconUnpublish.vue';

export default {
  mixins: [buttonMixin],
  components: {
    BaseIcon,
    IconUnpublish,
  },
  props: {
    variant: { type: String, default: 'danger' },
  },
};
</script>

<style lang="scss" scoped></style>
